module.exports = __webpack_public_path__ + "img/login.d67d5405.svg";